// Dubai guide: pre-summer AC checklist.
const content = {
    slug: 'pre-summer-ac-checklist',
    title: 'Pre-Summer AC Checklist for Dubai Homes | Before the Heat',
    description: 'A pre-summer AC checklist for Dubai: what to check yourself in March and April, what to book a technician for, and how to avoid a July breakdown.',
    eyebrow: 'Dubai · AC guide',
    h1: 'Pre-Summer AC Checklist for Dubai Homes',
    lead: 'Most AC breakdowns in Dubai happen in the first heatwave, when units that coasted through winter are suddenly asked to run all day. An hour of checks in March or April saves a sweltering wait for a technician in July.',
    datePublished: '2026-10-03',
    image: 'blog/living/repairman-doing-air-conditioner-service.jpg',
    imageAlt: 'AC being checked before summer',
    summary: {
        title: 'When to do it',
        items: [
            'March to mid-April: before temperatures pass 35°C and technicians get busy.',
            'After the last big dust storm of spring, so filters start summer clean.',
            'Before you travel for the summer, if the home will be closed up.',
        ],
    },
    sections: [
        {
            title: 'Checks you can do yourself',
            steps: [
                { title: 'Wash every filter', body: 'Behind the return grille (ducted) or the front panel (split). Rinse, dry fully, refit.' },
                { title: 'Run each unit for 20 minutes on cool', body: 'Note any that are noisy, slow to cool, smell musty or drip.' },
                { title: 'Look at outdoor units', body: 'Clear stored items and sand; check the fan spins and the coil isn\'t bent or blocked.' },
                { title: 'Check the drain outlets', body: 'Make sure condensate drains are not blocked by dust or debris outside.' },
                { title: 'Test the thermostat', body: 'Set it a few degrees below room temperature and confirm the unit responds.' },
            ],
        },
        {
            title: 'Book a technician if...',
            tone: 'muted',
            items: [
                'Any unit smells, drips or blows weak air after filter cleaning.',
                'The outdoor unit hums but the fan does not spin.',
                'There is frost on any pipe.',
                'A unit has not had a coil wash in the last year.',
                'You are leaving for the summer and want the home cool and dry when you return.',
            ],
        },
        {
            title: 'Leaving Dubai for the summer?',
            paragraphs: [
                'A closed apartment in August can reach high temperatures and humidity, which encourages mould on furniture and in the AC. Many residents leave one unit running at a moderate setting such as 28°C, or use a smart thermostat to cool the home a day before returning. Ask a neighbour or the building to check for leaks if you will be away for weeks.',
            ],
        },
    ],
    faqs: [
        {
            question: 'When should I service my AC before summer in Dubai?',
            answer: 'March or April, before the first heatwave and before technicians\' diaries fill up.',
        },
        {
            question: 'Should I book a coil wash or a normal cleaning before summer?',
            answer: 'If the unit has not had a coil wash in a year, or smells or cools weakly, book the coil wash. Otherwise a routine cleaning is enough.',
        },
    ],
    cta: {
        title: 'Book your pre-summer service',
        body: (c) => `AC cleaning from ${c.money(c.tables.general[0].wall)}; coil wash from ${c.money(c.tables.chemicalWash[0].wall)}.`,
        href: '/ae/ac-service-dubai',
        label: 'See AC service prices',
        bookSummary: 'pre-summer AC service in Dubai',
        bookLabel: 'Book a pre-summer visit',
    },
}

export default content
